import NewlyEnrolledTable from 'components/organisms/ccm-console/newly-enrolled-table';
import PartialsTable from 'components/organisms/ccm-console/partials-table';
import FollowUpTable from 'components/organisms/ccm-console/follow-up-table';
import WorkingQueue from 'components/organisms/ccm-console/working-queue';
import { useEffect, useRef, type FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { KeyNotesDrawer } from 'components/organisms/oneplaform/key-notes-drawer';
import ScrollToTopButton from 'components/atoms/scroll-to-top-button';
import DashboardLayout from 'components/templates/dashboard-layout';
import { useCCMDataQueryFilter } from 'infrastructure/hooks/ccm/console/use-ccm-data-query-filter';
import { useDrawer } from 'components/organisms/ccm-console/notes-drawer/hooks/use-drawer';
import { usePodAssignments } from 'infrastructure/hooks/ccm/use-pod-assignments';

import s from './styles.module.scss';

interface CCMConsolePageProps {}

const CCMConsolePage: FC<CCMConsolePageProps> = () => {
  const { filter, updateFilter } = useCCMDataQueryFilter();
  const {
    handleCloseDrawer,
    isOpenDrawer,
    patientGuid,
    patientInfo,
    handleNoteSaved,
  } = useDrawer();
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    hasPodAssignment,
    isLoading: podLoading,
    isError: podError,
  } = usePodAssignments('CCM');
  const guardApplied = useRef(false);

  useEffect(() => {
    if (podLoading || podError || guardApplied.current) return;
    guardApplied.current = true;

    if (!hasPodAssignment) {
      const hasStaleFilter = searchParams.get('podFilter');

      if (hasStaleFilter) {
        setSearchParams((prev) => {
          prev.delete('podFilter');
          return prev;
        });
      }
    }
    // searchParams intentionally omitted from deps: guardApplied ensures this runs
    // exactly once, reading URL state at that moment only. Including searchParams
    // would cause redundant re-firings on every URL change (all suppressed by
    // guardApplied anyway, but wasteful and misleading).
  }, [hasPodAssignment, podLoading, podError, setSearchParams]);
  return (
    <DashboardLayout
      showCcmHeaderActions
      ccmFilter={filter}
      updateCcmFilter={updateFilter}
    >
      <div className={s.wrapper}>
        <WorkingQueue />
        <NewlyEnrolledTable />
        <PartialsTable />
        <FollowUpTable />
        <KeyNotesDrawer
          isRPM={false}
          open={isOpenDrawer}
          onClose={handleCloseDrawer}
          patientGuid={patientGuid}
          patientInfo={patientInfo}
          onNoteSaved={handleNoteSaved}
        />
        <ScrollToTopButton />
      </div>
    </DashboardLayout>
  );
};

export default CCMConsolePage;
